var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIconColored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8276 6.66732C11.8276 9.99598 8.55185 13.4627 7.45185 14.5333C7.34937 14.6202 7.22463 14.6672 7.09642 14.6672C6.9682 14.6672 6.84346 14.6202 6.74099 14.5333C5.64099 13.4627 2.36523 9.99598 2.36523 6.66732C2.36523 5.25283 2.8637 3.89628 3.75097 2.89608C4.63823 1.89589 5.84163 1.33398 7.09642 1.33398C8.35121 1.33398 9.5546 1.89589 10.4419 2.89608C11.3291 3.89628 11.8276 5.25283 11.8276 6.66732Z",
    stroke: "#2563EB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09646 8.66602C8.07632 8.66602 8.87065 7.77059 8.87065 6.66602C8.87065 5.56145 8.07632 4.66602 7.09646 4.66602C6.1166 4.66602 5.32227 5.56145 5.32227 6.66602C5.32227 7.77059 6.1166 8.66602 7.09646 8.66602Z",
    stroke: "#2563EB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIconColored);
export default __webpack_public_path__ + "static/media/location_icon_colored.ab914f7ada0ff40977b0bbc1bbd02dcc.svg";
export { ForwardRef as ReactComponent };